import { useMemo } from 'react'
import { LucideIconName, WebsiteConfigPage } from '@bm-js/atlascloud-shared'
import { CText, Icon } from '@bm-js/atlascloud-ui'
import { SortableList } from './SortableList'

type Props = {
  pages: WebsiteConfigPage[]
  setPages: (pages: WebsiteConfigPage[]) => void
  selectPage: (page: WebsiteConfigPage | null) => void
  canMovePageDown: boolean
  pageAbove: string | null
  movePageDown: (pages: WebsiteConfigPage[], page: WebsiteConfigPage) => void
  movePageUp: (pages: WebsiteConfigPage[], page: WebsiteConfigPage) => void
}

export type PageWithId = WebsiteConfigPage & { id: string }

export default function SitemapSortable({
  pages,
  setPages,
  selectPage,
  canMovePageDown,
  movePageDown,
  movePageUp,
  pageAbove,
}: Props) {
  const pagesWithId = useMemo<PageWithId[]>(() => {
    return pages.map((page) => {
      return {
        ...page,
        id: page.uuid,
      }
    })
  }, [pages])

  return (
    <div>
      <SortableList<PageWithId>
        items={pagesWithId}
        onChange={setPages}
        renderItem={(item: PageWithId, i: number) => (
          <SortableList.Item item={item}>
            <div className='flex items-center gap-1 overflow-hidden'>
              <button onClick={() => selectPage(item)} title='Redigera sida'>
                <Icon name={LucideIconName.Pen} className='size-4' />
              </button>
              {pageAbove && (
                <button
                  onClick={() => movePageUp(pages, item)}
                  title={`Flytta ut sida till ${pageAbove}`}
                >
                  <Icon name={LucideIconName.CornerLeftUp} className='size-4' />
                </button>
              )}
              {canMovePageDown && pagesWithId[i + 1] && (
                <button
                  onClick={() => movePageDown(pages, item)}
                  title={`Flytta in sida i ${pagesWithId[i + 1].viewName}`}
                >
                  <Icon
                    name={LucideIconName.CornerRightDown}
                    className='size-4'
                  />
                </button>
              )}
              <CText className='whitespace-nowrap truncate text-sm'>
                {item.viewName}
              </CText>
            </div>
            <SortableList.DragHandle />
          </SortableList.Item>
        )}
      />
    </div>
  )
}
